<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <CommandTypeList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import CommandTypeList from '@/components/settings/parameters/commandTypes/CommandTypeList'
  import ActionButton from '@/components/button/ActionButton'

  export default {
    name: 'CommandTypes',
    components: {
      PageTitle,
      ActionButton,
      PageRowWrapper,
      CommandTypeList
    },
    methods: {
      onClickButton (e) {
        this.$router.push({ name: 'addcommandtype' })
      }
    }
  }
</script>
